export default __webpack_public_path__ + "static/media/phone-icon-big.3df3c117.svg";